// Потолок ускоренного просмотра уже сыгранного матча — общий для слайдера
// реплея (ReplayControlsContext) и слайдера демо-витрины главного меню
// (menuShowcase.js): оба крутят запись одного и того же формата (список
// действий + интервал), поэтому разгонять ее можно одинаково смело в обоих
// местах, одним числом на двоих
export const MAX_PLAYBACK_SPEED_MULTIPLIER = 20;

// С этой скорости просмотра записи тосты не показываются: на x10 и выше
// сообщения сменяют друг друга быстрее, чем их успеваешь прочитать, и только
// закрывают поле (см. GameToast)
export const TOASTS_HIDDEN_FROM_SPEED_MULTIPLIER = 10;

// До этой скорости просмотра записи (на странице записи и на витрине главного
// меню — по числу на их ползунках) анимации поля идут как в живой партии:
// отряды переходят по полю плавно, залпы выстрелов и удары ближнего боя
// показываются целиком, с обычной длительностью (см. playUnitMovementAnimation,
// playShotAnimation, playMeleeAnimation). Шаг воспроизведения анимацию не
// поджимает: проигрыватель записи ждет, пока она отыграет, и только потом
// исполняет следующее действие (см. ReplayRunner). Выше порога запись — уже
// перемотка: ждать там незачем, все происходит мгновенно
export const FIELD_ANIMATED_UP_TO_SPEED_MULTIPLIER = 5;

// Боты живой партии, ускоренные сильнее этого: их залпы и удары ближнего боя
// не показываются. Бот анимацию не ждет — следующее действие придет через его
// шаг, и анимация сжимается под этот шаг (см. resolveShotPaceMs); на коротком
// шаге она уже не читается, а залпы наезжали бы друг на друга
export const BOT_COMBAT_ANIMATED_UP_TO_SPEED_MULTIPLIER = 2;
